import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { createInitialState } from './state'

// Prefixo 'customer_chat/' em todas as chaves (types.js), no mesmo padrão dos demais
// módulos do repo (registrados sem `namespaced: true`).
export default {
  state: createInitialState(),
  actions,
  getters,
  mutations,
}
